import { Component, OnInit } from '@angular/core';
import { LoggingService } from '@EfsServices/logging.service';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { environment } from '@efsEnvironments/environment';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
    selector: 'app-setup-page',
    templateUrl: './setup-page.component.html',
    styleUrls: ['./setup-page.component.css'],
    standalone: false
})

export class SetupPageComponent implements OnInit {

  lockDown = false;
  bannerMessage = 'Maintenance in progress, no changes will be saved for the next 4';
  psRead = 'travellerSetup';

  browser;
  ieMessage = false;
  lockdownMsg = false;

  constructor(
    private loggingService: LoggingService,
    private guardLinkService: GuardLinkService,
    private router: Router,
    public route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    public permissionHandlingService: PermissionHandlingService,
  ) { }

  ngOnInit() {
    this.loggingService.logInfo('landed on Setup page');
    sessionStorage.setItem('clientId', 'null');
    sessionStorage.setItem('clientNm', 'null');
    sessionStorage.setItem('fromCorp', 'null');
    sessionStorage.setItem('toCorp', 'null');
    sessionStorage.setItem('planType', 'null');
    this.specialNavigation();
    // check for browser, dont use ie for now
    this.browser = navigator.userAgent;
    console.log('browser is ' + this.browser);
    if (navigator.userAgent.indexOf('rv:11.0') !== -1) {
      console.log('ie detected!');
      this.ieMessage = true;
      this.lockdownMsg = false;
      this.lockDown = true;
    } else {
      console.log('not detected!');
    }
  }

  logNavigation(link) {
    this.loggingService.logInfo('pressed ' + link + ' link');
  }

  // navigate to a specific module if a condition is met, ie coming from a different program
  specialNavigation() {
    console.log('In SpecialNavigation Method');
    console.log(sessionStorage.getItem('callerId'));
    if (sessionStorage.getItem('callerId') === 'travellerSetup') {
      console.log('Calling NavigateTo Method');
      this.navigateTo('production setup');
    }
  }

  navigateTo(moduleName) { // validate the link and navigate. add any new modules here
    console.log('In NavigateTo Method');
    this.guardLinkService.validateLink().subscribe(() => {
      // this.toggleSearchSI = true;
      if (moduleName === 'special instructions') {
        this.router.navigate(['setup/searchSpecialInstructions']);
        this.dataSharingService.shareData('moduleSI');
      }
      if (moduleName === 'prehold') {
        this.router.navigate(['setup/prehold']);
        this.dataSharingService.shareData('modulePH');
      }
      if (moduleName === 'delayed mail') {
        this.router.navigate(['setup/delayedMail']);
        this.dataSharingService.shareData('moduleDM');
      }
      if (moduleName === 'production setup') {
        console.log('Navigating to production setup');
        this.router.navigate(['setup/productionSetup']);
        this.dataSharingService.shareData('modulePS');
      }
      if (moduleName === 'production method') {
        this.router.navigate(['setup/productionMethod']);
        this.dataSharingService.shareData('modulePM');
      }
      if (moduleName === 'plan template') {
        this.router.navigate(['setup/planTemplate']);
        this.dataSharingService.shareData('modulePT');
      }
      if (moduleName === 'package template') {
        this.router.navigate(['setup/packageTemplate']);
        this.dataSharingService.shareData('modulePA');
      }
      if (moduleName === 'corp setup') {
        this.router.navigate(['setup/corpSetup']);
        this.dataSharingService.shareData('moduleCS');
      }
      if (moduleName === 'rule setup') {
        this.router.navigate(['setup/ruleSetup']);
        this.dataSharingService.shareData('moduleRS');
        sessionStorage.removeItem('ruleClassNm');
      }
      if (moduleName === 'mailerIdSetup') {
        this.router.navigate(['setup/mailerIdSetup']);
        this.dataSharingService.shareData('moduleRS');
        sessionStorage.removeItem('ruleClassNm');
      }
      if (moduleName === 'parameterEntry') {
        this.router.navigate(['setup/parameterEntry']);
        this.dataSharingService.shareData('modulePE');
        sessionStorage.removeItem('ruleClassNm');
      }
      if (moduleName === 'perfMeasurements') {
        this.router.navigate(['setup/perfMeasurements']);
        this.dataSharingService.shareData('modulePE');
        sessionStorage.removeItem('ruleClassNm');
      }
      if (moduleName === 'corpProfileSetup') {
        this.router.navigate(['setup/corpProfileSetup']);
        this.dataSharingService.shareData('moduleCP');
        sessionStorage.removeItem('ruleClassNm');
      }
    });
  }

}
